/**
 * 短剧管理 → 数据中心
 *
 * 子 Tab：
 * - 项目记录
 * - 合成任务
 *
 * 这只是一个容器组件，不引入新业务逻辑；子组件维持原有职责与状态。
 */

import { useState } from 'react';
import { FolderOpen, Film } from 'lucide-react';

import DirectorProjectsTab from './DirectorProjectsTab';
import DirectorCompositionsTab from './DirectorCompositionsTab';

type SubTab = 'projects' | 'compositions';

const SUB_TABS: Array<{ key: SubTab; label: string; icon: typeof FolderOpen }> = [
  { key: 'projects', label: '项目记录', icon: FolderOpen },
  { key: 'compositions', label: '合成任务', icon: Film },
];

export default function DirectorDataHubTab() {
  const [active, setActive] = useState<SubTab>('projects');

  return (
    <div className="max-w-6xl space-y-4">
      <div className="flex items-center gap-1 border-b border-light-border overflow-x-auto">
        {SUB_TABS.map((tab) => {
          const Icon = tab.icon;
          const activeFlag = active === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActive(tab.key)}
              className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                activeFlag
                  ? 'border-accent-blue text-accent-blue'
                  : 'border-transparent text-light-muted hover:text-light-text'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
            </button>
          );
        })}
      </div>

      <div>
        {active === 'projects' && <DirectorProjectsTab />}
        {active === 'compositions' && <DirectorCompositionsTab />}
      </div>
    </div>
  );
}
